<template>
  <h2 class="text-center tablet:text-2xl text-xl font-bold">
    <slot>サブタイトル</slot>
  </h2>
</template>
